import { render, staticRenderFns } from "./OptionMenu.vue?vue&type=template&id=0c09d22b&scoped=true&"
import script from "./OptionMenu.vue?vue&type=script&lang=js&"
export * from "./OptionMenu.vue?vue&type=script&lang=js&"
import style0 from "./OptionMenu.vue?vue&type=style&index=0&id=0c09d22b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c09d22b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardText,VCardTitle,VHover,VIcon})
